import { render } from "./CapitalDetail.vue?vue&type=template&id=7f345c12"
import script from "./CapitalDetail.vue?vue&type=script&lang=js"
export * from "./CapitalDetail.vue?vue&type=script&lang=js"

import "./CapitalDetail.vue?vue&type=style&index=0&id=7f345c12&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__